import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const goldPin = new L.DivIcon({
  className: "",
  html: `<div style="width:28px;height:28px;border-radius:50%;background:linear-gradient(135deg,#C9A45C,#E8C97E);box-shadow:0 4px 14px rgba(201,164,92,0.5);border:2px solid #FFF8EE"></div>`,
  iconSize: [28,28], iconAnchor: [14,14],
});

export default function MapView({ items=[], center=[39.5,-98.5], zoom=4, onSelect, height="100%" }){
  const valid = items.filter(i => typeof i.lat === "number" && typeof i.lng === "number");
  const initial = valid.length ? [valid[0].lat, valid[0].lng] : center;
  return (
    <div style={{height, width:"100%"}} data-testid="map-view">
      <MapContainer center={initial} zoom={valid.length?6:zoom} style={{height:"100%",width:"100%",borderRadius:"24px"}} scrollWheelZoom>
        <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" attribution='&copy; OpenStreetMap &copy; CARTO' />
        {valid.map(i => (
          <Marker key={i.experience_id||i.property_id||i.user_id} position={[i.lat, i.lng]} icon={goldPin}
            eventHandlers={{ click: () => onSelect && onSelect(i) }}>
            <Popup>
              <div style={{minWidth:180}}>
                <div style={{fontWeight:600}}>{i.title || i.name}</div>
                <div style={{fontSize:12,opacity:0.7}}>{i.city}, {i.state}</div>
                {i.price && <div style={{marginTop:6,color:"#FF7A45",fontWeight:600}}>${i.price}</div>}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
